import { MAXIMUM_RETRY_DELAY } from "./constants";
/**
 * Calculate a capped, fully-jittered exponential backoff time.
 */
export var defaultDelayDecider = function defaultDelayDecider(delayBase, attempts) {
  return Math.floor(Math.min(MAXIMUM_RETRY_DELAY, Math.random() * Math.pow(2, attempts) * delayBase));
};